import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { categoryService } from '../../services/api';

export default function Layout({ children }) {
  const [cats, setCats] = useState([]);
  useEffect(() => {
    categoryService.getAll().then(res => setCats(res.data)).catch(() => setCats([]));
  }, []);
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <header className="border-b">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-xl font-bold">AI Digest</a>
            <nav className="hidden md:flex gap-4">
              {cats.slice(0,6).map(c => (
                <Link key={c.id} to={`/category/${c.slug}`} className="text-sm text-gray-600 hover:text-blue-600">
                  {c.name}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>
      <main>{children}</main>
      <footer className="border-t">
        <div className="max-w-7xl mx-auto px-4 py-6 text-sm text-gray-500">
          © {new Date().getFullYear()} AI Digest
        </div>
      </footer>
    </div>
  );
}
